import React, { useState, FC, useEffect, useRef } from "react";
import { RouteComponentProps, useLocation, } from "react-router-dom";
import "../../Components/Home/home.scss";
import "../../Components/Home/home.css";
import { NavObjectType, lddGlobalSessionFirmInfo, lddGlobalSessionInfo } from "../../Components/navigationTypes";
import { useDispatch, } from 'react-redux';
import { setSessionState, setSessionInfo, lddStateObject } from '../../redux/reducer'
import { useAppSelector } from "../../redux/hooks";
import TopBar from "./TopBar";
import MainPage from "./MainPage";
import ReactFrame from "../../Components/reactFrame/reactFrame";
import { NavigationContext } from "../../Context/NavigationContext";
import RenewSessionPopup from "../../Components/RenewSessionPopup";
import Footer from "../../Components/footer/footer";
import TermsModal from "./Lawyer/TermsModal";


declare var SessionStack;
type SomeComponentProps = RouteComponentProps;

const DocService: FC<SomeComponentProps> = ({ history, match }) => {
    const location = useLocation();
    const paramsJSON = new URLSearchParams(location.search).get("params")
    const [page, setPage] = useState<NavObjectType>(paramsJSON ? JSON.parse(paramsJSON) : {
        component: "formlist",
    });
    const [shouldShowTerms, setShouldShowTerms] = useState(false);
    const showTermsOfUse = () => setShouldShowTerms(true);
    const closeTermsOfUse = () => setShouldShowTerms(false);
    
    const search = window.location.search;
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    const URLsid = new URLSearchParams(search).get('SessionID');
    const dispatch = useDispatch();

    const SessionRenewInterval = useRef(null);

    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);


    function GetReactFrame() {
        if (page.reactFrame !== '' && page.reactFrame !== undefined && page.reactFrame !== null) {
            return <ReactFrame reactFrame={page.reactFrame} />
        } else {
            return <></>;
        }
    }
    
    async function handleGenSessionInfo(resSession, responsePromises, isLDDUser: boolean): Promise<lddGlobalSessionInfo> {
        const [resUser, resFirm] = await Promise.all(responsePromises.map(r => r.json()));
        const { UserID, StationID, isMSLogin, Username } = resSession.result;
        const UserInfo = resUser.result;
        const Admin = UserInfo.Administrator === "1";
        let { FirstName, Initials, LastName, FullName, SubUserID, UserEmail, UserPhone, UserCellPhone, MSLoginEmail } = UserInfo;
        if (!(Initials > "")) {
            Initials = "";
            if (FirstName > "") {
                Initials = FirstName.toUpperCase().substring(0, 1);
            }
            if (LastName > "") {
                Initials += LastName.toUpperCase().substring(0, 1);
            }
        }
        if (!(FullName > "")) {
            if (FirstName > "") {
                FullName = FirstName
            }
            if (LastName > "") {
                FullName += ` ${LastName}`
            }
        }
        const appCode = "DS"
        let globalFirmInfo: lddGlobalSessionFirmInfo;
        if (isLDDUser) {
            const FirmInfo = resFirm.result.firm;
            let { FirmName, FirmPhone, FirmCity, FirmFax, FirmEmail, FirmStreet1, FirmProvince, FirmPostalCode, Lawyers } = FirmInfo;
            globalFirmInfo = {
                account: Username,
                id: UserID,
                name: FirmName,
                phone: FirmPhone,
                city: FirmCity,
                fax: FirmFax,
                email: FirmEmail,
                address: FirmStreet1,
                province: FirmProvince,
                postalcode: FirmPostalCode,
                Lawyers: Lawyers,
                Staffs: []
            };
            try {
                if (typeof (SessionStack) !== "undefined") {
                    SessionStack && SessionStack.identify({
                        userId: Username + '-' + StationID, // Replace the USER-ID with the user id from your app
                        // email: 'user@example.com', // Not required
                        displayName: appCode + '2-' + Username + '-' + StationID, // Not required
        
                        // Add your own custom user variables here.
                        role_str: 'user',
                        // pricingPlanType_str: 'premium',
                        // pricingPlanCost_real: 49.99
                    });
                }
        
            } catch (e) {
                console.log(`SessionStack identify crash - ${e}`)
            }
        } else {
            globalFirmInfo = {
                account: Username,
                id: UserID,
                name: "",
                phone: "",
                city: "",
                fax: "",
                email: "",
                address: "",
                province: "",
                postalcode: "",
                Lawyers: [],
                Staffs: []
            }
        }
    
        const SessionInfo: lddGlobalSessionInfo = {
            appCode: appCode,
            appCountry: "CA",
            appProvince: "Ontario",
            appProvinceShort: "ON",
            sid: URLsid,
            user: {
                isAdmin: Admin,
                account: StationID,
                id: SubUserID,
                firstname: FirstName,
                lastname: LastName,
                fullname: FullName,
                initials: Initials,
                email: UserEmail,
                phone: UserPhone,
                cell: UserCellPhone
            },
            firm: globalFirmInfo,
            MSLoginEmail: (isMSLogin) ? MSLoginEmail : "",
        };
        if (isLDDUser) {
            try {
                // Staff Info
                const staffPromise = await fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${SessionInfo.appProvinceShort}/${UserID}/get/list?SessionID=${URLsid}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        searchType: "all_staff_member",
                        page: 0
                    })
                });
                const resStaff = await staffPromise.json();
                SessionInfo.firm.Staffs = resStaff.result;
            } catch (e) {
                ;
            }
        }
        SessionInfo.isLDDUser = isLDDUser;
        return { ...SessionInfo };
    }
    


        //  - Load SessionInfo (even not async)
    useEffect(() => {
        async function fetchData() {
            const res = await fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/cur/uv/get/curUser?SessionID=${URLsid}`);
            if (res.status === 403) {
                window.location.href = "/loginldd.html?ErrorMsg=Session timeout."
            }
            const resSession = await res.json();
            const { UserID, StationID, IsLDDUser } = resSession.result;
            let responsesJSON;
            let isLDDUserBool = true;
            if (IsLDDUser === false) {
                // LSUC login
                responsesJSON = await Promise.all([
                    fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${UserID}/uv/get/user?id=${StationID}&SessionID=${URLsid}`),
                ]);
                isLDDUserBool = false;
            } else {
                responsesJSON = await Promise.all([
                    fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${UserID}/uv/get/user?id=${StationID}&SessionID=${URLsid}`),
                    fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${UserID}/uv/get/firm?SessionID=${URLsid}`),
                ]);
            }
            const SessionInfo: lddGlobalSessionInfo = await handleGenSessionInfo(resSession, responsesJSON, isLDDUserBool);
            dispatch(setSessionInfo(SessionInfo));
        }

        // Load SID into state
        if (SESSION_INFO?.sid !== URLsid) {
            dispatch(setSessionState(URLsid));
        }
        // load the rest SESSION_INFO
        fetchData();
        return () => {
            if (SessionRenewInterval.current) {
                clearInterval(SessionRenewInterval.current)
            }
        }
    }, [])

    function changeFrame(navObj: NavObjectType): void {
        navObj = { ...navObj, init: true }
        
        let compatFile = "compatshell";
        if (process.env.REACT_APP_BUILD_URL && process.env.REACT_APP_BUILD_URL !== "") {
            compatFile = compatFile + "_" + process.env.REACT_APP_BUILD_URL;
        }
        history.push("?SessionID=" + URLsid + "&params=" + encodeURIComponent(JSON.stringify(navObj)));
        // update page
        setPage({ ...navObj });
    }

    return (
        <NavigationContext.Provider value={changeFrame}>
        <>
        <RenewSessionPopup URLsid={URLsid} info={SESSION_INFO} page={page} />
        {SESSION_INFO && 
            <>
                <TopBar /> 
                    <main className="ldd-width main-container">
                        <MainPage
                            info={SESSION_INFO}
                            page={page}
                            dataroot={livedataRootContainer.dataRoot}
                            reactFileComponent={GetReactFrame()}
                        />
                        <div className='legal-footer'>
                            <p><a onClick={showTermsOfUse}>Terms of Use.</a></p>
                        </div>
                    </main>
                <Footer />
                <TermsModal show={shouldShowTerms} onHide={closeTermsOfUse} />
            </>
        }
        </>
        </NavigationContext.Provider>
    );
};

export default DocService;

export const RightSideContext = React.createContext(
    {
        rightSideBoolean: false,
        account: ''
    }
);
